import React from "react";
import { NavLink } from "react-router-dom";
//import { BuildingLibraryIcon } from "@heroicons/react/24/outline";
import { useGetHospitalDetailsQuery } from "../services/hospitalApi";
import { getUserPrefferedName } from "../auth";
import { pageRoutes } from "../constants/pageRoutes";
import { logo2Icon, healthsystemIcon } from "@/src/assets";

const DoctorDashboardSidebar2 = ({ isAdminDashboard, isNurseDashboard, hospitalId, hospitalName }) => {
  const preferredName = getUserPrefferedName();

  // If nurse, hospitalId should come from session or props
  const nurseHospitalId = isNurseDashboard ? hospitalId : null;

  const { data: newHospitalData, isLoading } = useGetHospitalDetailsQuery(
    nurseHospitalId || preferredName,
    {
      skip: !(nurseHospitalId || preferredName),
    }
  );

  const hospital = newHospitalData?.[0] || {};
  const displayHospitalName = hospital?.Name || hospitalName || "Hospital Name";
  const displayHospitalId = hospital?.HospitalID || hospitalId || "N/A";

  const links = isNurseDashboard
    ? [
        {
          to: pageRoutes.nurseList,
          label: "Appointments List",
          icon: "../assets/admin/fluent_list-rtl-16-filled (1).png",
          iconActive: "../assets/admin/fluent_list-rtl-16-filled (2).png",
        },
      ]
    : isAdminDashboard
    ? [
        {
          to: pageRoutes.providerList,
          label: "Provider List",
          icon: "../assets/admin/healthicons_doctor.png",
          iconActive: "../assets/admin/healthicons_doctor (1).png",
        },
        {
          to: "/admindashboardappointmentlist",
          label: "Appointments List",
          icon: "../assets/admin/fluent_list-rtl-16-filled (1).png",
          iconActive: "../assets/admin/fluent_list-rtl-16-filled (2).png",
        },
        //{
        //to: "/admindashboardpatientlist",
        //label: "Patients List",
        //icon: "../assets/admin/fluent_list-rtl-16-filled (1).png",
        //iconActive: "../assets/admin/fluent_list-rtl-16-filled (2).png",
        //},
        {
          to: "/admindashboardnewpatient",
          label: "Patient Management",
          icon: "../assets/admin/Layer_1.png",
          iconActive: "../assets/admin/Layer_1 (1).png",
        },
        {
          to: "/scheduleappointment",
          label: "Schedule Appointment",
          icon: "../assets/admin/uil_schedule.png",
          iconActive: "../assets/admin/uil_schedule (1).png",
        },
        {
          to: "/admindashboardeditpatient",
          label: "Patient Details",
          icon: "../assets/patient/activePatientSidebar.svg",
          iconActive: "../assets/patient/patientSidebar.svg",
        },
      ]
    : [
        {
          to: "/dashboard",
          label: "Appointments",
          icon: "../assets/admin/uil_schedule.png",
          iconActive: "../assets/admin/uil_schedule (1).png",
        },
        {
          to: "/doctor-patients",
          label: "Patients",
          icon: "../assets/admin/fluent_list-rtl-16-filled (2).png",
          iconActive: "../assets/admin/fluent_list-rtl-16-filled (2).png",
        },
      ];

  return (
    <div className="w-1/5 h-screen flex flex-col justify-between bg-[#233876]">
      {/* — Top: Logo + Nav — */}
      <div>
        {/* Logo */}
        <div className="p-2 flex justify-center">
          <div className="inline-block">
            <img
              src={logo2Icon}
              alt="DocAide Logo"
              className="w-[148px] h-[45px] top-[25px] left-[87px]"
            />
          </div>
        </div>

        <hr className="border-gray-300 mx-6" />

        <nav className=" mt-16 flex flex-col items-center mx-4 space-y-6">
          {links.map(({ to, label, icon, iconActive }) => (
            <NavLink
              key={to}
              to={to}
              end
              className={({ isActive }) =>
                [
                  "flex items-center justify-left w-full px-2 py-2 border-2 border-solid transition font-poppins font-medium text-base",
                  isActive
                    ? "bg-white text-blue-700"
                    : "bg-transparent text-white border-transparent hover:border-white",
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  {icon && (
                    <img
                      src={isActive ? iconActive : icon}
                      alt={`${label} icon`}
                      className="w-5 h-5 mr-3 transition duration-200"
                    />
                  )}
                  <span className="font-medium">{label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* — Bottom: Hospital Card — */}
      {isLoading ? (
        <div className="mb-6 px-4">
          <hr className="border-gray-300" />
          <div className="mt-4 bg-gradient-to-r from-blue-600 to-blue-900 rounded-lg py-4 px-4 flex items-center animate-pulse">
            <div className="w-6 h-6 bg-white/40 rounded mr-3" />
            <div>
              <div className="h-4 bg-white/40 rounded w-40 mb-2" />
              <div className="h-3 bg-white/30 rounded w-32" />
            </div>
          </div>
        </div>
      ) : (
        <div className="mb-6 px-4">
          <hr className="border-gray-300" />
          <div className="mt-4 bg-gradient-to-r from-blue-600 to-blue-900 rounded-lg py-4 px-4 flex items-center gap-2">
            <img src={healthsystemIcon} alt="Health System Icon" className="w-5 h-5"/>
            <div>
              <p className="text-white font-semibold">
                {displayHospitalName}
              </p>
              {/* <p className="text-sm text-white mt-1">
                Hospital ID: {displayHospitalId}
              </p> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoctorDashboardSidebar2;